<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>

          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索" @on-enter="searchinput"/>
           </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border :columns="columns" :data="tableData"
                 ></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>

        </Card>
      </i-col>
    </Row>

  </div>
</template>

<script>

  import {
    getroomlist,
    chagneroom,
    roomtoanother
  } from '@/api/scinfo/scinfo.js'

  import { getsysparameterList } from '@/api/system/sys_parameter'

  // import {Notification} from 'element-ui';

  let moment = require('moment')
  export default {

    data () {
      return {
        spinShow: false,
        fullscreenLoading: false,
        searchVal: '',
        tableData: [],
        pageNum: 1, // 当前页码
        pageTotal: 0, // 数据总数
        pageSize: 15, // 每页条数
        columns: [
          {
            type: 'selection',
            key: 'Id',
            width: 60,
            align: 'center'
          },
          {
            title: '编号',
            key: 'Roomid',
            width: 100,
            align: 'center',
            sortable: true
          },
          {
            title: '名称',
            key: 'Iname',
            width: 100,
            align: 'center',
            sortable: true
          },
          {
            title: '状态',
            key: 'Istate_CN',
            width: 120,
            align: 'center',
            sortable: true
          },
          {
            title: '单位',
            key: 'Icomid_CN',
            align: 'center',
            sortable: true
          },
          {
            title: '求职者',
            key: 'Iperid_CN',
            width: 200,
            align: 'center',
            sortable: true
          },
          {
            title: '招聘会',
            key: 'Jid_CN',
            width: 200,
            align: 'center',
            sortable: true
          },

          {
            title: '操作',
            key: 'handle',
            width: 150,
            align: 'center',
            render: (h, params) => {
              if (params.row.Istate == 4) {
                return h('div', [
                  h(
                    'Button',
                    {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '恢复'
                  )
                ])
              } else {
                return h('div', [

                  h(
                    'Button',
                    {
                      props: {
                        type: 'error',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.changstate(params.row)
                        }
                      }
                    },
                    '故障'
                  ),
                  h(
                    'Button',
                    {
                      props: {
                        type: 'info',
                        size: 'small'
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.roomtoanother(params.row)
                        }
                      }
                    },
                    '转移'
                  )
                ])
              }
            }
          }
        ]
      }
    },
    methods: {
      getRoomlist (key, value) {
        this.spinShow = true
        getroomlist(this.pageNum, this.pageSize, key, value).then(res => {
          if (res.data.code === 0) {
            this.pageTotal = res.data.count
            this.tableData = res.data.data
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
          this.spinShow = false
        })
      },

      roomtoanother (paramsRow) {
        // console.log(paramsRow)
        setTimeout(() => {
          roomtoanother(paramsRow, 'POST').then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)

              if (this.searchVal) {
                this.getRoomlist(this.searchVal)
              } else {
                this.getRoomlist()
              }
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }, 1000)
      },
      changstate (paramsRow) {
        setTimeout(() => {
          chagneroom(paramsRow, 'PUT').then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)

              if (this.searchVal) {
                this.getRoomlist(this.searchVal)
              } else {
                this.getRoomlist()
              }
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        }, 1000)
      },

      // 翻页
      changePage (value) {
        this.pageNum = value
        if (this.searchVal) {
          this.getRoomlist(this.searchVal)
        } else {
          this.getRoomlist()
        }
      },
      // 切换分页
      handlePageSize (value) {
        this.pageSize = value
        this.pageNum = 1
        if (this.searchVal) {
          this.getRoomlist(this.searchVal)
        } else {
          this.getRoomlist()
        }
      },
      searchinput () {
        if (this.searchVal) {
          this.getRoomlist(this.searchVal)
        } else {
          this.getRoomlist()
        }
      }
    },

    watch: {
      searchVal (val) {
        this.searchVal = val
      }
    },
    mounted () {
      this.getRoomlist()
    }
  }

</script>

<style lang="less" scoped>
  .search-con {
    padding: 10px 0;

    .search {
      &-col {
        display: inline-block;
        width: 200px;
      }

      &-input {
        display: inline-block;
        width: 200px;
        margin-left: 2px;
      }

      &-btn {
        margin-left: 2px;
      }
    }
  }
</style>
